export const navigateOrTabToItem = (history, event = false, navUrl) => {
  if (event.ctrlKey || event.metaKey) {
    // Open the new URL in a new tab if Ctrl or Command key is held down
    window.open(navUrl, '_blank');
  } else {
    // Navigate in the current tab
    history.push(navUrl);
  }
};

export const tabToItem = (event, navUrl) => {
  if (event.ctrlKey || event.metaKey) {
    // Open the new URL in a new tab if Ctrl or Command key is held down
    window.open(navUrl, '_blank');
  }
};
